import { api } from "./client";
import type { WorkoutSummary, WorkoutDetail } from "@/types";

// Phase 24.7.3 T3 — manual workout entry. Mirrors backend
// ManualWorkoutCreate Pydantic schema (app/schemas/workout.py).
export interface ManualWorkoutCreate {
  date: string; // ISO date YYYY-MM-DD
  sport:
    | "run"
    | "bike"
    | "swim"
    | "strength"
    | "yoga"
    | "walk"
    | "hike"
    | "row"
    | "ski"
    | "other";
  duration_min: number; // 1-600
  rpe: number; // 1-10
  tss_override?: number | null;
  notes?: string | null;
}

export async function createManualWorkout(
  payload: ManualWorkoutCreate,
): Promise<WorkoutSummary> {
  const { data } = await api.post<WorkoutSummary>("/workouts/manual", payload);
  return data;
}

export async function listWorkouts(params: {
  days?: number;
  limit?: number;
  sport?: string | null;
} = {}, signal?: AbortSignal): Promise<WorkoutSummary[]> {
  const query = new URLSearchParams();
  if (params.days != null) query.set("days", String(params.days));
  if (params.limit != null) query.set("limit", String(params.limit));
  if (params.sport) query.set("sport", params.sport);
  const suffix = query.toString() ? `?${query.toString()}` : "";
  const { data } = await api.get<WorkoutSummary[]>(`/workouts${suffix}`, { signal });
  return data;
}

export async function getWorkout(id: number): Promise<WorkoutDetail> {
  const { data } = await api.get<WorkoutDetail>(`/workouts/${id}`);
  return data;
}
